
import Viewer from "@toast-ui/editor/dist/toastui-editor-viewer";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";
import { defineComponent, onMounted, ref, watch } from "vue";

const __default__ = defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: ""
    },
    maxWidth: {
      type: String
    }
  },
  emits: ["update:modelValue"],

  setup(props) {
    const editor = ref();
    const editorDiv = ref();

    const maxWidthViewer = ref(props.maxWidth);

    onMounted(() => {
      editor.value = new Viewer({
        el: editorDiv.value,
        initialValue: props.modelValue
      });
    });

    watch(
      () => props.modelValue,
      () => {
        editor.value = new Viewer({
          el: editorDiv.value,
          initialValue: props.modelValue
        });
      }
    );

    return {
      editor,
      editorDiv,
      maxWidthViewer
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "0f1970b5": (_ctx.maxWidthViewer)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__